class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');

    /* The notification element lives in the cart-notification section. On any
       page where that section is absent (and on this store's custom eco-header
       layout it can be), every line below used to throw
       "Cannot read properties of null (reading 'addEventListener')" straight
       out of the constructor. That kills the whole custom-element upgrade, so
       nothing else in this file runs either. Bailing out early is the correct
       behaviour: with no notification element there is nothing to wire up. */
    if (!this.notification) return;

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.header = document.querySelector('sticky-header');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    if (!this.notification) return;
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    /* Dawn assumed every section in getSectionsToRender() has both a matching
       element in the DOM and matching HTML in the cart response. That is not
       true here: this store's header is a custom section (eco-header) with no
       #cart-icon-bubble element, and the theme ships no cart-icon-bubble
       section either, so both lookups legitimately come back empty.

       Unguarded, that threw a TypeError partway through the loop, which
       aborted renderContents() before it ever reached open() - the popup was
       wired up correctly but could never appear. Skipping absent sections
       lets the ones that do exist render and the notification open.

       The header count is refreshed separately by refreshCart() in
       eco-header.js, so nothing is lost by skipping cart-icon-bubble. */
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) return;

      const html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (html === null) return;

      sectionElement.innerHTML = html;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
